import { EntityTypes } from './enums/entityTypes';

export interface RequestMessage {
  messageId: string;
  matchId: string;
  entityType: EntityTypes.requestMessage;
  orgId: string;
  userId: string;
  message: string;
  edited: boolean;
  created: number;
  lastUpdated: number;
}

export interface CreateRequestMessageInput {
  matchId: string;
  orgId: string;
  userId: string;
  message: string;
}
